import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-frequence',
  standalone: true,
  imports: [
    TraitementDataComponent,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-frequence.component.html',
  styleUrl: './traitement-data-frequence.component.scss',
})
export class TraitementDataFrequenceComponent {
  @Input() patient: Patient | undefined;
}